module.exports = __webpack_public_path__ + "img/160.04dec305.jpg";